<div class="PGLocationPicker {{readonly ? '' : 'PGLocationPicker--NotReadonly'}}">
    <div class="PGLocationPicker-Top">
        <input type="text" class="form-control form-control-sm PGLocationPicker-Search {{ readonly ? 'PGLocationPicker-Search--Readonly' : '' }}" #searchbox
            [attr.id]="fieldId || null"
            [attr.aria-label]="placeholder || ('pg-location-picker.a11y.search' | locTranslate)"
            [placeholder]="placeholder || ('pg-location-picker.a11y.search' | locTranslate)"/>
        <div class="PGLocationPicker-Map {{readonly ? 'PGLocationPicker-Map--ReadOnly' : ''}} GoogleMaps" #gmaps
            role="region" [attr.aria-label]="'pg-location-picker.a11y.map' | locTranslate"></div>

        @if (showAdvanced) {
            <div class="PGLocationPicker-Advanced p-2">
                <div class="row">
                    <div class="col input-group">
                        <div class="input-group-text">
                            LAT
                        </div>
                        <input [readonly]="readonly" class="form-control" [disabled]="isGeocodingAdvancedValue" [(ngModel)]="advancedValue[0]" (change)="onAdvancedValueChange()"
                            [attr.aria-label]="'pg-location-picker.a11y.latitude' | locTranslate"/>
                    </div>
                    <div class="col input-group">
                        <div class="input-group-text">
                            LON
                        </div>
                        <input [readonly]="readonly" class="form-control" [disabled]="isGeocodingAdvancedValue" [(ngModel)]="advancedValue[1]" (change)="onAdvancedValueChange()"
                            [attr.aria-label]="'pg-location-picker.a11y.longitude' | locTranslate"/>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="PGLocationPicker-Bottom">
        <div class="PGLocationPicker-Slaves ps-1 pt-1">
            @if (hasEditableSlaves()) {
                <i class="fa-regular fa-map-marker me-2" aria-hidden="true"></i>
                @if(!isLoadingAddress) {
                    @if(value) {
                        <span [innerHTML]="getSlavesValueList() || ('pg-location-picker.unknown-address' | locTranslate)"></span>
                        @if(!readonly) {
                            <button type="button" class="btn btn-link p-1 ms-1" (click)="openEditAddress()"
                                [attr.aria-label]="'pg-location-picker.a11y.edit-address' | locTranslate">
                                <i class="fa-regular fa-edit" aria-hidden="true"></i>
                            </button>
                        }
                    }
                    @else {
                        <span class="text-muted">{{ 'pg-location-picker.no-selection' | locTranslate }}</span>
                    }
                }
            }
        </div>
        @if (!readonly && allowAdvanced) {
            <div class="PGControlsAdvanced text-end ms-1 mt-1">
                <button type="button" class="btn btn-sm btn-{{ showAdvanced ? 'primary' : 'outline-primary' }}" (click)="showAdvanced = !showAdvanced"
                    [attr.aria-pressed]="showAdvanced"
                    [attr.aria-label]="'pg-location-picker.a11y.toggle-advanced' | locTranslate">
                    <i class="fa-regular fa-code" aria-hidden="true"></i>
                </button>
            </div>
        }
    </div>
</div>

<ng-template #editAddress>
    <div class="modal-header">
        <h5 class="modal-title">{{ 'pg-location-picker.modal-title' | locTranslate }}</h5>
        <button type="button" class="modal-close btn btn-link" (click)="editAddressDismiss()"
            [attr.aria-label]="'forms-main.a11y.close' | locTranslate">
            <i class="fa-regular fa-times" aria-hidden="true"></i>
        </button>
    </div>
    <div class="modal-body">
        <div class="row">
            @for(key of editAddressKeys; track key) {
                <div class="col-6 form-group">
                    <label [attr.for]="'pg-location-edit-' + key"><b>{{ 'pg-location-picker.modal-field-' + key | locTranslate }}</b></label>
                    <input class="form-control" [attr.id]="'pg-location-edit-' + key" [(ngModel)]="editAddressValues[key]"/>
                </div>
            }
        </div>
    </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="editAddressDismiss()">
                <i class="fa-regular fa-undo" aria-hidden="true"></i><span>{{ 'pg-location-picker.modal-button-cancel' | locTranslate }}</span>
            </button>
            <button type="button" class="btn btn-primary" (click)="editAddressSave()">
                <i class="fa-regular fa-check" aria-hidden="true"></i><span>{{ 'pg-location-picker.modal-button-ok' | locTranslate }}</span>
            </button>
        </div>
</ng-template>
